import _extends from '@babel/runtime/helpers/esm/extends';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import React from 'react';
import elementResizeDetectorMaker from 'element-resize-detector';

var SizeMe =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SizeMe, _React$Component);

  function SizeMe() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this._root = void 0;
    _this._parentNode = void 0;
    _this._elementResizeDetector = void 0;
    _this.state = {
      width: _this.props.defaultHeight || 0,
      height: _this.props.defaultHeight || 0
    };

    _this._handleResize = function (element) {
      _this.setState({
        width: element.clientWidth,
        height: element.clientHeight
      });
    };

    return _this;
  }

  var _proto = SizeMe.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this._root && this._root.parentNode && this._root.parentNode instanceof this._root.parentNode.ownerDocument.defaultView.HTMLElement) {
      this._parentNode = this._root.parentNode;
      this._parentNode.style.overflow = 'hidden';
      this._elementResizeDetector = elementResizeDetectorMaker({
        strategy: 'scroll'
      });

      this._elementResizeDetector.listenTo(this._parentNode, this._handleResize);

      this._handleResize(this._parentNode);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._elementResizeDetector && this._parentNode) {
      this._elementResizeDetector.removeListener(this._parentNode, this._handleResize);
    }
  };

  _proto._renderContent = function _renderContent() {
    var _this$props = this.props,
        children = _this$props.children,
        disableHeight = _this$props.disableHeight,
        disableWidth = _this$props.disableWidth,
        onResize = _this$props.onResize;
    var _this$state = this.state,
        width = _this$state.width,
        height = _this$state.height;

    if (typeof children === 'function') {
      var params = {};

      if (!disableHeight) {
        params.height = height;
      }

      if (!disableWidth) {
        params.width = width;
      }

      onResize(params);
      return children(params);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        style = _this$props2.style,
        className = _this$props2.className;
    return React.createElement("div", _extends({
      style: style,
      className: className
    }, {
      ref: function ref(i) {
        return _this2._root = i;
      }
    }), this._renderContent());
  };

  return SizeMe;
}(React.Component);

SizeMe.defaultProps = {
  disableHeight: false,
  disableWidth: false,
  onResize: function onResize() {},
  style: {}
};
export default SizeMe;